import { privateApi } from "../api/axios";

export const getLabelsAdministrative = async () => {
    try {
        const response = await privateApi.get("api/timeslabels/administrative");
        return response;
    } catch (error) {
        throw error;
    }
}

export const getLabelsEvents = async () => {
    try {
        const response = await privateApi.get("api/timeslabels/events");
        return response;
    } catch (error) {
        throw error;
    }
}

export const getEventsLabel = async () => {
    try {
        const response = await privateApi.get("api/timeslabels/events/request");
        return response;
    } catch (error) {
        throw error;
    }
}